import { blankPickerLabel, blankPickerValue } from '../filters';

/** Shortest search worth an API call, matching the location and customer fields on the Research form. */
export const minimumSearchLength = 3;

/** One record a lookup can resolve to. `id` is the only part a filter saves. */
export interface LookupItem {
  id: string;
  name: string;
  /** Second line of the option, to tell apart records that read alike */
  detail?: string;
}

/**
 * Not a record at all, but the option that turns the filter into a blank one. It has to sit in the list rather than
 * arrive from a search, because there is nothing to search for — a leg with no driver has no driver to type.
 */
export const blankLookupItem: LookupItem = { id: blankPickerValue, name: blankPickerLabel };

export const isBlankLookupItem = (item: LookupItem) => item.id === blankLookupItem.id;

export interface LookupProps {
  label: string;
  multiple: boolean;
  /** Whether the picker offers the blank option, which the filter's field decides rather than the lookup */
  canBeBlank: boolean;
  /** Selected IDs. A single-select lookup holds at most one. */
  value: string[];
  onChange: (ids: string[]) => void;
}

export interface LookupListProps extends LookupProps {
  items: LookupItem[];
  isLoading: boolean;
  onSearch: (text: string) => void;
}

export const getLookupLabel = (option: unknown) => {
  const item = option as LookupItem;
  // The blank option has no ID to show, and "(Blank) ()" is not a thing to put on screen
  return isBlankLookupItem(item) ? item.name : `${item.name} (${item.id})`;
};
